import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  public faqsCount = Array.from(new Array(23), (val, index) => index + 1);

  constructor() { }

  ngOnInit() {
  }

}
